import { Fragment, useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { Link, useLocation } from "react-router-dom";
import { PAGES } from "../../../routeConfig";

export const MyFavCard = ({ item, index }) => {
  const [favItem, setFavItem] = useState();
  const { wishListAll, setWishListAll } = useContext(GlobalContext);
  const { deleteNewList } = useGlobalFunction();
  const { showDialogAlert, showFlashScreen, hideNoteAlert } = useNoteAlert();
  const location = useLocation();

  useEffect(() => {
    setFavItem(item);
  }, [item]);

  if (!favItem) {
    return null;
  }
  const handleDeleteClick = (e) => {
    e.preventDefault();
    showDialogAlert({
      content: "Do you want to delete this list permanently?",
      title: "Delete Confirmation",
      primaryBtn: { caption: "Yes, Remove", onClick: deleteList },
      scondaryBtn: { caption: "Cancel", onClick: hideNoteAlert },
    });
  };
  const deleteList = async () => {
    try {
      showFlashScreen(true);
      let response = await deleteNewList(favItem.listId);
      if (response) {
        showFlashScreen(false);
        setWishListAll(response);
        hideNoteAlert();
      }
    } catch (r) {
      showFlashScreen(false);
    }
  };
  return (
    <div className="create-favListAdd">
      <div className="favListing">
        <p className="favListing-lft favListing-red">{String(favItem.listName).charAt(0)}</p>
        <div className="favListing-rht">
          <Link to={PAGES.FAVORITEPRODUCT_LIST + "/" + favItem.listId} state={{ from: location }}>
            {favItem.listName}
          </Link>
          <ul>
            <li>
              <span>Item:</span>
              {favItem.productCount}
            </li>
            <li>
              <i className="fa-solid fa-circle" />
            </li>
            <li>
              <span>Created:</span>
              {favItem.createdDate}
            </li>
          </ul>
        </div>
      </div>
      <div className="favListing-links">
        <Link to={PAGES.FAVORITEPRODUCT_LIST + "/" + favItem.listId} className="favListing-links-edit">
          Edit
        </Link>
        <a href="#" role="button" onClick={handleDeleteClick} className="favListing-links-delete">
          Delete
        </a>
      </div>
    </div>
  );
};
